import { env } from '@js/utils/env'
import { AxiosResponse } from 'axios'

import magentoAxios from '../../api/global/magentoAxios'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'

interface ChangePasswordPayload {
  currentPassword: string
  newPassword: string
  recaptchaToken?: string
}

interface ChangePasswordResponse {
  data: {
    changeCustomerPassword: {
      id: number
      email: string
    } | null
  }
  errors?: Array<{ message: string }>
}

export const changeCustomerPasswordMutation = gql`
  mutation changeCustomerPassword(
    $currentPassword: String!
    $newPassword: String!
  ) {
    changeCustomerPassword(
      currentPassword: $currentPassword
      newPassword: $newPassword
    ) {
      id
      email
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const changePassword = async (payload: ChangePasswordPayload): Promise<void> => {
  const { data }: AxiosResponse<ChangePasswordResponse> = await magentoAxios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    recaptchaToken: payload.recaptchaToken,
    headers: {
      'Content-Type': 'application/json',
      Store: getStoreName(),
    },
    data: {
      query: changeCustomerPasswordMutation,
      variables: {
        currentPassword: payload.currentPassword,
        newPassword: payload.newPassword,
      },
    },
  } as any)

  if (data.errors) {
    throw data.errors[0].message
  }
}